import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
  transformResponse: [data => JSON.parse(data).data],
  withCredentials: true,
  headers: { 'App-Name': 'blaze' }
})

const prefix = 'messaging'

export const subscribe = payload => {
  return axiosInstance.post(`${prefix}/subscribe`, payload)
}

export const unsubscribe = payload => {
  return axiosInstance.post(`${prefix}/unsubscribe`, payload)
}
